export default __webpack_public_path__ + "static/media/options.de6b7c51.png";